import React, { useState } from 'react';
import { Field } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ButtonToolbar } from 'reactstrap';
import { format } from 'date-fns';
import SmartButton from '../../../shared/components/SmartButton';
import SelectVirtualized from '../../../shared/components/form/SelectVirtualized';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import {
  REPORT_PARAMETERS,
  REPORT_TYPES,
  RELATION_OBJECT_TYPE,
} from '../../../shared/utils/constants';
import { generateReport, openReport } from '../../../shared/utils/smartutils';

const BuilderFormStudentReportCard = ({
  t,
  close,
  students,
  dispatch,
  selectedClass,
}) => {
  const [selectedStudent, setSelectedStudent] = useState({});

  const changeSelectedStudent = (value) => {
    setSelectedStudent(value);
  };

  const showLoading = () => {
    dispatch(changeLoadingTrue());
  };

  const hideLoading = () => {
    dispatch(changeLoadingFalse());
  };

  const generateSchoolReport = () => {
    close();
    showLoading();
    const formData = new FormData();

    formData.append(
      REPORT_PARAMETERS.REPORTTYPE,
      REPORT_TYPES.RELA_SCHOOLREPORT_BY_STUDENT
    );
    let studentIds;
    if (selectedStudent.value === RELATION_OBJECT_TYPE.ALL) {
      studentIds = students.filter(
        (report) => report.value !== RELATION_OBJECT_TYPE.ALL
      );
      if (studentIds) {
        studentIds = studentIds
          .map((report) => report.student.value)
          .join(', ');
      }
    } else {
      studentIds = selectedStudent.student.value;
    }
    formData.append(REPORT_PARAMETERS.pCO00TURM, selectedClass.id);
    formData.append(REPORT_PARAMETERS.pCOD_ALUNOS, studentIds);
    formData.append(
      REPORT_PARAMETERS.pANO,
      format(new Date(selectedClass.releaseDate), 'yyyy')
    );
    generateReport(formData)
      .then(async (res) => {
        openReport(res.data);
        hideLoading();
      })
      .catch((e) => {
        hideLoading();
        console.error(e);
      });
  };

  return (
    <form className="theme-light form mt-2">
      <div className="form__form-group">
        <span className="form__form-group-label">{t('general.student')}</span>
        <div className="form_form-group-field">
          <Field
            name="student"
            component={SelectVirtualized}
            options={students}
            onChange={changeSelectedStudent}
            placeholder={t('general.placeholders.select')}
          />
        </div>
      </div>
      <ButtonToolbar className="modal__footer">
        <SmartButton
          color="danger"
          label={t('general.cancel')}
          onClick={close}
        />
        <SmartButton
          label={t('general.print')}
          color="primary"
          onClick={() => generateSchoolReport()}
          disabled={!selectedStudent.value}
        />
      </ButtonToolbar>
    </form>
  );
};

BuilderFormStudentReportCard.propTypes = {
  t: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
  students: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
  dispatch: PropTypes.func.isRequired,
  selectedClass: PropTypes.shape(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
    })
  ).isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(BuilderFormStudentReportCard)
);
